import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';

import { CategoriesComponent } from './categories.component';
import { SelectedPipe } from './selected.pipe';

const MODULES = [
  CommonModule,
  MatCheckboxModule,
  TranslateModule
];

const COMPONENTS = [
  CategoriesComponent
];

const PIPES = [
  SelectedPipe
];

@NgModule({
  imports: [
    MODULES
  ],
  declarations: [
    COMPONENTS,
    PIPES
  ],
  exports: [
    CategoriesComponent
  ]
})
export class CategoriesModule { }
